import tokens from '../new-design-tokens';
var colors = tokens.colors;
export default (function () {
  return {
    colour: {
      formInfo: colors.info.subdued.default,
      formInfoText: colors.neutral.heavy.default,
      formError: colors.critical.subdued.default,
      formErrorText: colors.neutral.heavy.default,
      formErrorBorder: colors.critical.trim.default,
      formSuccess: colors.success.subdued.default,
      formSuccessText: colors.neutral.heavy.default,
      formRequired: colors.critical.base.default
    }
  };
});